import uuid from 'uuid-random';

import { TGetTermsAndConditionsHistoryResponse } from '../../types';

export const parseResponse = (data: TGetTermsAndConditionsHistoryResponse) => {
    return data?.data?.playerAcceptedTerms.reverse().map(term => ({ id: uuid(), ...term })) || [];
};
